import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User changes caption font, color, position, or effect',
  name: 'caption_style_configured',
  params: [
    {
      description: 'The id of the video',
      name: 'video_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Selected caption font',
      name: 'font',
      required: true,
      type: 'string',
    },
    {
      description: 'Selected caption color',
      name: 'color',
      required: true,
      type: 'string',
    },
    {
      description: 'Selected caption position',
      name: 'position',
      required: true,
      type: 'enum',
      values: ['top', 'center', 'bottom'],
    },
    {
      description: 'Selected caption effect type',
      name: 'effect_type',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
